import BoardUtils from '../Game/BoardUtils';
import { IGameState } from '../State/Store/store';

export const checkGameComplete = (state: IGameState) => {
    // win conditions
    const goal = state.StateLevel.goal.type;
    const target = state.StateLevel.goal.target;
    if (goal === 'pair' && target === 0) {
        if (state.StateBoard.boardTiles.length === 0) {
            return 'win';
        }
    } else {
        if (state.StateLevel.goal.total === state.StateLevel.goal.target) {
            return 'win';
        }
    }

    return null;
};

export const checkGameStuck = (state: IGameState) => {
    if (state.StateBoard.boardTiles.length === 0) {
        return null;
    }
    const available = state.StateBoard.available;
    const boardMap = state.StateBoard.boardMap;
    const matches = BoardUtils.findMatchesFromAvailable(available, boardMap);
    return matches.length === 0;
};
